module.exports = __webpack_public_path__ + "img/HeaveHo.3a0eb1b3.png";